import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

/** button hovered searchPageRightPanelAppFilterShowMore */
export const onAppFilterShowMoreHovered = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	isConnected,
}: {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	isConnected: boolean;
}): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterShowMore`,
	action: 'hovered',
	attributes: {
		additionalAttributes: {
			isConnected,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
